<mat-tab-group (focusChange)="resizeMap(map)">
  <mat-tab>
    <ng-template mat-tab-label>Übersicht</ng-template>
    <mat-card class="inset-card">
      <mat-card-title>
        <mat-icon>store</mat-icon>
        <span>{{ customer.name }}</span>
      </mat-card-title>

      <mat-card-content>
        <ul class="list-unstyled">
          <li class="row site-row" *ngFor="let site of customer.sites">
            <div class="col-sm-4 site-item">
              <h4>{{ site.name }}</h4>
              <p *ngIf="site.address.zip">{{ site.address.street }} <br />
                {{ site.address.zip }} {{ site.address.city }}</p>
              <p *ngIf="!site.address.zip">vollständige Adresse fehlt</p>
              <p>
                <a href="mailto:{{ site.email }}" *ngIf="site.email != ''">{{
                  site.email }}</a><br />
                <a href="tel:{{ site.telephone }}" *ngIf="site.telephone != ''">{{
                  site.telephone }}</a>
              </p>
            </div>
            <div class="col-sm-2">
              <p>
                <button type="button" mat-raised-button (click)="createReport(site)">Bericht erstellen
                </button>
              </p>
            </div>
            <p>
              <mat-chip-list *ngIf="site.category">
                <mat-chip [style.backgroundColor]="site.category?.color">{{ site.category?.name }}</mat-chip>
              </mat-chip-list>
            </p>
          </li>
        </ul>
        <app-data-table [data]="reports" (rowClick)="router.navigate(['report', $event.id])"
                        class="table table-striped">
          <table-column label="Datum">
            <ng-template table-column-content #col="content">
              {{ col.record.appointment?.date_time | date }}
            </ng-template>
          </table-column>
          <table-column label="Kontakt">
            <ng-template table-column-content>
              {{ col.record.appointment?.contactPerson?.name }}
            </ng-template>
          </table-column>
          <table-column label="Betreff">
            <ng-template table-column-content>
              {{ col.record.subject}}
            </ng-template>
          </table-column>
          <table-column label="Inhalt">
            <ng-template table-column-content>
              {{ col.record.description}}
            </ng-template>
          </table-column>
        </app-data-table>

      </mat-card-content>
      <mat-card-actions>
        <a routerLink="edit" mat-raised-button>
          Bearbeiten
        </a>
      </mat-card-actions>
    </mat-card>
    <mat-card class="inset-card">
      <mat-card-title>
        <mat-icon>today</mat-icon>
        Termine/Besuche
      </mat-card-title>
      <mat-card-content>
        <app-data-table [data]="futureAppointments" [class]="'table table-striped'">
          <table-column label="Datum">
            <ng-template table-column-content #appRow="content">
              {{ appRow.record.date_time | date }}
            </ng-template>
          </table-column>
          <table-column label="Ort">
            <ng-template table-column-content>
              {{ appRow.record.site?.name }}
            </ng-template>
          </table-column>
          <table-column label="Inhalt">
            <ng-template table-column-content>
              <mat-icon>{{appRow.record.on_site ? 'business': 'call'}}</mat-icon>
            </ng-template>
          </table-column>
          <table-column>
            <ng-template table-column-content>
              <button mat-raised-button *ngIf="appRow.record.on_site" type="button" color="primary"
                      (click)="navService.navigateTo(appRow.record.site)">navigieren
              </button>
              <a mat-raised-button *ngIf="!appRow.record.on_site" type="button"
                 [href]="'tel:' + appRow.record.site.telephone" color="primary">anrufen</a>
            </ng-template>
          </table-column>
        </app-data-table>
      </mat-card-content>
    </mat-card>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>Karte</ng-template>
    <agm-map [latitude]="calcCenterFromCoordinates().lat" [longitude]="calcCenterFromCoordinates().lng" #map>
      <agm-marker *ngFor="let site of customer.sites" [latitude]="site.address?.lat" [longitude]="site.address?.lng">{{
        site.name}}
        <agm-info-window>
          <strong>{{ site.name}}</strong>
          <p> {{ site.address.street}}<br />
            {{ site.address.zip}} {{ site.address.city}} </p>
          <p>
            <button mat-raised-button type="button" color="primary" (click)="navigateTo(site)">navigieren</button>
          </p>
        </agm-info-window>
      </agm-marker>
    </agm-map>
  </mat-tab>
</mat-tab-group>





// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/customer/customer-view/customer-view.component.html